import { formatMemoryForDisplay } from "components/Environment/Create/utils";
import ArchitectureBadge from "components/Environment/shared/ArchitectureBadge";
import React from "react";
import { formatGpuName } from "utils/gpuNames";

interface GPUInstanceAttributeProps {
  instanceType: string;
  isGPUInstance: boolean;
  vcpu?: number;
  memory?: string | number;
  gpuManufacturer?: string;
  gpuName?: string;
  gpuMemory?: string;
  gpuCount?: number;
  architectures?: string[];
  plainArchitecture?: boolean;
  variant?: "default" | "small";
}

export const InstanceAttribute: React.FC<GPUInstanceAttributeProps> = ({
  instanceType,
  isGPUInstance,
  vcpu,
  memory,
  gpuManufacturer,
  gpuName,
  gpuMemory,
  gpuCount,
  architectures,
  plainArchitecture = false,
  variant = "default",
}) => {
  const architectureBadge = (
    <ArchitectureBadge
      architectures={architectures}
      compact
      variant={plainArchitecture ? "metadata" : "badge"}
      className={isGPUInstance ? "mt-1.5" : undefined}
    />
  );

  if (!vcpu || !memory) {
    return (
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm flex mr-1">{instanceType}</span>
        {architectureBadge}
      </div>
    );
  }

  return (
    <div className="flex w-max flex-col gap-1.5">
      {!isGPUInstance ? (
        <div className="flex flex-wrap items-center gap-2">
          <span
            className={`text-${variant === "small" ? "xs" : "sm"} flex mr-3 items-center`}
          >
            {vcpu} {vcpu === 1 ? "CPU" : "CPUs"}{" "}
            <span className="text-zinc-600 mx-2"> • </span>{" "}
            {formatMemoryForDisplay(memory || "")} RAM
          </span>
          {architectureBadge}
        </div>
      ) : (
        <div>
          <span
            className={`text-${
              variant === "small" ? "xs" : "sm"
            } flex mr-3 font-semibold`}
          >
            {`${gpuManufacturer} ${formatGpuName(gpuName || "")} (${formatMemoryForDisplay(gpuMemory)})`}
          </span>
          <span
            className={`text-${variant === "small" ? "xs" : "sm"} flex mr-3`}
          >
            {gpuCount} GPUs x {vcpu} CPUs
          </span>
          <span className={`text-${variant === "small" ? "xs" : "sm"} flex`}>
            {formatMemoryForDisplay(memory)} RAM
          </span>
          {architectureBadge}
        </div>
      )}
    </div>
  );
};
